import { Service } from '@angular/core';
import { environment } from '@environments/environment';
import { FeatureFlag, FeatureFlags } from '@environments/feature-flags';

@Service()
export class FeatureFlagsService {
  private readonly flags: FeatureFlags = environment.features;

  isEnabled(flag: FeatureFlag): boolean {
    return Object.hasOwn(this.flags, flag) && this.flags[flag] === true;
  }
}
